import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const FieldCount = ({ value, row }) => (
  <div data-testid="field-count-cell" className="field-count-cell">
    <div className={row.isExpanded ? "cell-header" : "cell-header -hidden"}>
      No. of Fields
    </div>
    <div>{value}</div>
  </div>
);

FieldCount.propTypes = {
  value: PropTypes.number.isRequired,
  row: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default FieldCount;
